import React from "react";
import { REF_KINDS } from "../ExploreTab.consts";
import { getFieldRefInfo } from "../ExploreTab.utils";
import ConfigRefCell from "./ConfigRefCell";
import ConfigRefListCell from "./ConfigRefListCell";
import EntityRefCell from "./EntityRefCell";

const RefCell = ({ field, value, version, defaultLanguage, isEditable }) => {
  const refInfo = getFieldRefInfo(field);
  if (!refInfo) return null;
  if (refInfo.kind === REF_KINDS.CONFIG && refInfo.isList) return <ConfigRefListCell field={field} value={value} />;
  if (refInfo.kind === REF_KINDS.CONFIG) return <ConfigRefCell field={field} value={value} isEditable={isEditable} />;
  return <EntityRefCell field={field} value={value} version={version} defaultLanguage={defaultLanguage} isEditable={isEditable} />;
};

export default RefCell;
